import { MonthSelect } from '../../../DateTime'
import { Control } from '../Control'

function ControlMonth({ value, onChange, ...controlProps }) {
  function handleChange(nextValue) {
    onChange(value, { value: nextValue })
  }

  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      <MonthSelect
        borderless
        disabled={value.omitted}
        value={value.value ?? null}
        onChange={handleChange}
      />
    </Control>
  )
}

export default ControlMonth
